var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinicActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 17H17.0005M13.2505 2H5.75049C3.50049 2 2.75049 3.3425 2.75049 5V17H16.2505V5C16.2505 3.3425 15.5005 2 13.2505 2Z",
    stroke: "#f9bc03",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50115 5V8.75M7.62615 6.875H11.3762M11.0462 11.75H7.94865C7.56615 11.75 7.24365 12.065 7.24365 12.455V17H11.7437V12.455C11.7453 12.3626 11.7284 12.2708 11.694 12.1851C11.6596 12.0993 11.6084 12.0213 11.5434 11.9556C11.4784 11.8899 11.4009 11.8379 11.3155 11.8026C11.2301 11.7673 11.1386 11.7494 11.0462 11.75Z",
    stroke: "#f9bc03",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicActive);
export default __webpack_public_path__ + "static/media/clinicActive.dd0657281027b0c915fd0e0009a7bb37.svg";
export { ForwardRef as ReactComponent };